// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"07c92d69","271":"30be60cc","298":"bf4adf95","453":"8945f81c","535":"cd102e25","719":"9979e8e5","727":"a47374fc","741":"e2425927","766":"4629c624","823":"964c3229","913":"aeebe11d","920":"21790951"}[chunkId] + ".chunk.js";
};